/*global gtag*/
import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');

    if (consent === 'granted') {
      // User has already consented
      updateConsent('granted');
    } else if (consent === 'denied') {
      // User has already denied
      updateConsent('denied');
    } else {
      // Show banner - no decision yet
      setShowBanner(true);
    }
  }, []);

  const updateConsent = (value) => {
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        'analytics_storage': value
      });
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'granted');
    updateConsent('granted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'denied');
    updateConsent('denied');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <p>
          Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic du site.
          En cliquant sur "Accepter", vous consentez à l'utilisation de cookies analytiques.
        </p>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Accepter
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
